import { ChangeDetectionStrategy, Component, inject, input, output } from '@angular/core';

import type { SupportedThemesT } from '@recruitee/theme';
import { IconButtonComponent } from '@recruitee/user-interface';

import { KiwiHrPromoComponent } from '../kiwi-hr-promo/kiwi-hr-promo.component';
import { KiwiHrPromoAnalytics } from '../kiwi-hr-promo.analytics';

@Component({
  selector: 'rti-kiwi-hr-promo-dashboard',
  templateUrl: './kiwi-hr-promo-dashboard.component.html',
  styleUrls: ['./kiwi-hr-promo-dashboard.component.less'],
  imports: [IconButtonComponent, KiwiHrPromoComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class KiwiHrPromoDashboardComponent {
  private readonly analytics = inject(KiwiHrPromoAnalytics);
  protected theme = input.required<SupportedThemesT>();
  protected close = output();
  protected ctaClick = output();

  public ngAfterViewInit(): void {
    this.analytics.trackBannerDisplay();
  }
}
